'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require('./block-elements.json')
};



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/defaults.js
// module id = 436
// module chunks = 95715928098905 168707334958949